import { UseAnalyticsServiceHook } from './analytics.types'
import {
  useAmplitude,
  useClarity,
  useGoogleAnalytics
} from './service-handlers'

export const useAnalytics: UseAnalyticsServiceHook = (user, config) => {
  useGoogleAnalytics(user, config?.googleAnalytics)
  useAmplitude(user, config?.amplitude)
  useClarity(user, config?.clarity)
}
